module.exports = __webpack_public_path__ + "img/engage2.8b670e5b.jpg";